<c-card *transloco="let t">
  <c-card-body class="px-2">

    <app-worker-reports-menu></app-worker-reports-menu>

    <div class="row">
      <div class="col-sm-8">
        <h3>{{ t('Report: Worker Permissions') }}</h3>
        <p>{{ t('View permission status for all workers (mirrors the in-app Permissions screen)') }}</p>
      </div>
      <div class="col-sm-4 text-end">
        <div class="btn-group mb-2" role="group">
          <button type="button" class="btn btn-light" (click)="getWorkers()">
            <span *ngIf="!okService.loading"><i class="fa-solid fa-rotate-right"></i></span>
            <span *ngIf="okService.loading"><i class="fa-solid fa-spinner fa-spin"></i></span>
            {{ t('Refresh') }}
          </button>
          <button type="button" class="btn btn-primary" (click)="export()">
            <i class="fa-solid fa-download"></i> {{ t('Export') }}
          </button>
        </div>
      </div>
    </div>

    <div class="card mb-2">
      <div class="card-header" data-bs-toggle="collapse" data-bs-target="#permissionsFilter" aria-expanded="true">
        <i class="fa-solid fa-chevron-down"></i> {{ t('Filter Results') }}
      </div>
      <div class="show" id="permissionsFilter">
        <div class="card-body">
          <form cForm>
            <div class="row d-flex mb-2">
              <label class="col-sm-2 col-form-label text-end" for="search">
                <b>{{ t('Search') }}</b>
              </label>
              <div class="col-sm-4">
                <input cFormControl id="search" name="search" placeholder="{{ t('Search') }}" [(ngModel)]="filter.search"/>
              </div>
            </div>

            <div class="row d-flex mb-2">
              <label class="col-sm-2 col-form-label text-end" for="monitors">
                <b>{{ t('Monitor') }}</b>
              </label>
              <div class="col-sm-4">
                <ng-select
                  [items]="monitors"
                  name="monitor"
                  [(ngModel)]="filter.monitors"
                  multiple="true"
                  bindLabel="name"
                  bindValue="id">
                </ng-select>
              </div>

              <ng-container *ngIf="okService.groups.length > 0 && okService.hasFeature('groups')">
                <label class="col-sm-2 col-form-label text-end" for="groups">
                  <b>{{ t('Group') }}</b>
                </label>
                <div class="col-sm-4">
                  <ng-select
                    [items]="groups"
                    name="group"
                    [(ngModel)]="filter.groups"
                    multiple="true"
                    bindLabel="name"
                    bindValue="id">
                  </ng-select>
                </div>
              </ng-container>
            </div>

            <div class="row d-flex justify-content-center mb-2">
              <div class="col-sm-3 d-flex justify-content-end">
                <button cButton class="btn btn-info text-white" type="submit" (click)="updateFilter()">
                  <i class="fa-solid fa-magnifying-glass"></i>
                  <span class="d-none d-lg-inline">{{ t('Search') }}</span>
                </button>
              </div>
              &nbsp;&nbsp;&nbsp;&nbsp;
              <div class="col-sm-3">
                <button cButton class="btn btn-light" type="button" (click)="clearFilter()">
                  <i class="fa-solid fa-xmark"></i>
                  <span class="d-none d-lg-inline">{{ t('Clear Filter') }}</span>
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

    <c-row *ngIf="workers">
      <c-col>
        <div class="table-responsive">
          <table
            [hover]="true"
            [responsive]="true"
            [striped]="true"
            align="middle"
            cTable
            class="mb-0 border"
          >
            <thead>
              <tr>
                <th scope="col">{{ t('PIN') }}</th>
                <th scope="col">{{ t('Worker Name') }}</th>
                <th scope="col">{{ t('Platform') }}</th>
                <th scope="col">{{ t('Overall') }}</th>
                <th scope="col" *ngFor="let col of permissionColumns">{{ col.title }}</th>
                <th scope="col">{{ t('Last Update') }}</th>
                <th scope="col"></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let worker of workers">
                <td>
                  <c-badge color="info">{{ u.formatWorkerPin(worker.pin) }}</c-badge>
                </td>
                <td>{{ worker.name }}</td>
                <td>{{ worker.platform }}</td>
                <td>
                  <c-badge [color]="worker.summary?.all_ok ? 'success' : 'danger'">
                    {{ worker.summary?.all_ok ? t('OK') : t('Issues') }}
                  </c-badge>
                </td>
                <td *ngFor="let col of permissionColumns" class="text-center">
                  <ng-container *ngIf="permissionCell(worker, col.key) as cell">
                    <c-badge [color]="statusBadgeColor(cell.status)">{{ cell.label }}</c-badge>
                  </ng-container>
                  <span *ngIf="!permissionCell(worker, col.key)">—</span>
                </td>
                <td>{{ worker.last_update }}</td>
                <td>
                  <button color="info" cButton class="me-1 btn-sm text-white" [routerLink]="['/mgmt/worker', worker.worker_id]" [queryParams]="{ tab: 'permissions' }">
                    {{ t('View') }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </c-col>
    </c-row>

  </c-card-body>
</c-card>
